import { Switch } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';

const ChangeLanguage = ({ handleChange, lang }) => {
    return (
        <>
            <div>
                <span>Farsi</span>
                <Switch
                    checked={lang === 'en'}
                    color="default"
                    onChange={handleChange}
                    inputProps={{ 'data-testid': 'switch' }}
                />
                <span>English</span>
            </div>
        </>
    );
};
ChangeLanguage.propTypes = {
    handleChange: PropTypes.func,
    lang: PropTypes.string
};

export default ChangeLanguage;
